const config = {
  apiKey: 'AIzaSyBqTwXHEDRBVQZ9hcVPc1AUzeejzDbeaX8'
};

export default config;
